<template>
  <div class="modal-body">
    <div class="row mx-2">
      <div class="form-inline">
        <div class="input-group mb-4 border rounded-pill p-1">
          <input type="search" placeholder="Search .. " aria-describedby="button-addon3"
                 class="form-control ml-1 bg-none border-0"
                 v-model="searchParamsForSelection.search"
          >
          <div class="input-group-append border-0">
            <button id="btnSelectCircular" type="button" class="btn btn-link text-primary">
              <font-awesome-icon icon="search" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 table-responsive">
      <table class="table table-hover" style="width: 100%;">
        <thead class="thead-light">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Lettter Number</th>
          <th scope="col">Subject</th>
          <th scope="col">Date</th>
          <th scope="col">Cat</th>
          <th scope="col">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-show="loading">
          <td colspan="100%">
            <base-loader></base-loader>
          </td>
        </tr>
        <tr :key="index" v-for="(circular,index) in circularsForSelection" v-show="circularsForSelection && !loading">
          <th scope="row">{{index + 1}}</th>
          <td style="word-wrap: break-word">{{circular.letter_no}}</td>
          <td style="word-wrap: break-word"> {{circular.subject}}</td>
          <td style="word-wrap: break-word">{{dateEliteFormat(circular.date)}}</td>
          <td style="font-size: 14px;padding: 0;">{{circular.circular_code}}</td>
          <td>
            <div class="text-right">
              <button class="btn btn-sm btn-primary" @click="$emit('setSelected',circular)">
                <font-awesome-icon icon="check"></font-awesome-icon>
                SELECT
              </button>
            </div>
          </td>
        </tr>
        <tr v-show="(circularsForSelection.length <= 0) && !loading">
          <td colspan="100%">
            <div class="row">
              <div class="col-12">
                <h5>
                  <font-awesome-icon icon="ban" class="text-danger"></font-awesome-icon>
                  NO CIRCULAR(S) FOUND
                </h5>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <base-pagination :page-object="pagination" @settingPage="setPage"></base-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLoader from "@/components/base/BaseLoader";
import {mapActions, mapGetters} from "vuex";
import {AppService} from "@/service/app.service";
import {toNumber} from "lodash";
export default {
  name: "SelectCircular",
  components:{BaseLoader},
  props:{
   circularIssueId:{
     type:Number,
     default(){
       return 0;
     },
   },
   circularCategoryId:{
      type:Number,
       default(){
         return 0;
       },
    }
  },
  data(){
    return{
      searchParamsForSelection:{
        page:1,
        search:"",
      },
      loading:false
    }
  },
  computed:{
    ...mapGetters(
        [
          'pagination',
          'circularsForSelection'
        ]
    ),
  },
 async created() {
    this.paginateParams=_.debounce(this.setToOne,750)

  },

  watch:{
    'searchParamsForSelection.search'(){
      this.paginateParams();
    }
  },
  methods:{
    ...mapActions(
        [
          'getCircularForSelection',
        ]
    ),
   async updateParams(){
      this.loading=true
      await this.getCircularForSelection(
          {
            ...this.searchParamsForSelection,
            circular_category_id:this.circularCategoryId,
            circular_issue_id:this.circularIssueId,
          }
      )
      this.loading=false
    },
    dateEliteFormat(date){
      return AppService.dateEliteFormat(date);
    },
    async setToOne(){
      await this.setPage(1);
    } ,
    async setPage(e){
      this.searchParamsForSelection.page=e
      await this.updateParams()
    }
  }
}
</script>

<style scoped>

</style>